import { sizing, type SizingProps } from '@material-ui/system'
import { rem } from 'polished'
import styled from 'styled-components'

interface IPdfViewerStyledProps extends SizingProps {}

export const PdfViewerStyled = styled.div<IPdfViewerStyledProps>`
  font-size: ${rem(16)};
  ${sizing}

  iframe {
    border: none;
  }
`
